import type { AcidGasSceneState } from './acidGasExplore';
import { createAcidGasScene } from './acidGasScene';
import { LabCanvas3D } from './LabCanvas3D';

/** Conical flask, delivery tube and gas syringe, driven by the "How much gas?" model. */
export function AcidGas3D({ state, playing, label }: { state: AcidGasSceneState; playing: boolean; label: string }) {
  return <LabCanvas3D build={createAcidGasScene} state={state} playing={playing} label={label} hint="Drag to turn the apparatus" />;
}
